<!--
 * @ Author: Your name
 * @ Create Time: 2019-06-05 12:28:38
 * @ Modified by: Your name
 * @ Modified time: 2019-07-20 15:29:51
 * @ Description: 修改密码弹窗
 -->
<template>
  <div class='editpwd-wrapper'>
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="120px">
      <el-form-item label="修改密码" prop="pass">
        <el-input v-model="ruleForm.pass" autocomplete="off"
          size="small" clearable type='password'></el-input>
      </el-form-item>
      <el-form-item label="确认修改密码" prop="password">
        <el-input type='password' v-model="ruleForm.password" autocomplete="off"
          size="small" clearable></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { EDITPASS } from '../../libs/api'
import { aesEncrypt } from '../../libs/utils/encrypt'
import { parseTime } from '../../libs/utils/parseTime'
import { onlyNumberLetter } from '../../libs/utils/validCheck'

export default {
  name: 'editPwd',
  data() {
    const onlyNumberLetters = (rule, value, callback) => {
      onlyNumberLetter(rule, value, callback)
    }
    return {
      ruleForm: {
        pass: '',
        password: ''
      },
      rules: {
        pass: [{ required: true, trigger: 'blur', message: '请输入密码' },
          { validator: onlyNumberLetters, trigger: 'blur' }],
        password: [{ required: true, trigger: 'blur', message: '请输入确认密码' },
          { validator: onlyNumberLetters, trigger: 'blur' }]
      },
      editPwdUrl: EDITPASS.updatePwd
    }
  },
  methods: {
    submitForm(formName, parent) {
      console.log('parent', parent)
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ruleForm.pass !== this.ruleForm.password) {
            this.$message.error('请确认密码和确认密码是否一致')
            return
          }

          // this.loginForm.password = aesEncrypt(this.loginForm.password, 'USER')

          const pwd = aesEncrypt(`${this.ruleForm.password},${parseTime(Date.now(), '{y}{m}{d}{h}{i}{s}')}`)
          const param = { password: pwd, id: sessionStorage.getItem('userId') }
          this.$http.post(this.editPwdUrl, param)
            .then(res => {
              // 这里请求修改密码接口， 修改成功后跳转至登录页
              if (res.data.code === 1) {
                this.$router.push('/login')
                return
              }
              this.$notify.error({
                title: '错误',
                message: res.data.msg || '修改密码失败'
              })
            })
            .catch(message => {
              this.$notify.error({
                title: '错误',
                message
              })
            })
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
.editpwd-wrapper{
  width: 300px;
}
</style>
